// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ql-container.ql-snow {\r\n  height: auto;\n}\n.ql-editor {\r\n  height: 320px;\r\n  overflow-y: scroll;\n}\r\n", ""]);
// Exports
module.exports = exports;
